import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BaseComponent from './BaseComponent';
import Project from './Project';
import Intro from './Intro';
import Alert from './Alert';
import Confirm from './Confirm';
import Maze from './Maze';
import Diary from './Diary';
import MazeResult from './MazeResult';
import Follow from './Follow';
import Complete from './Complete';
import Manual from './Manual';
import LectureProgress from './LectureProgress';
import LectureProgress2 from './LectureProgress2';
import TextBookLectureProgress from './TextBookLectureProgress';
import HardwareList from './HardwareList';
import HardwareDownload from './HardwareDownload';
import Element from './Element';
import ListTransfer from './ListTransfer';
import UserSelectList from './UserSelectList';
import CurriculumAlert from './CurriculumAlert';
import CurriCulumAnswer from './CurriculumAnswer';
import CurriculumStudyHint from './CurriculumStudyHint';
import CurriculumStudyComplete from './CurriculumStudyComplete';
import Simple from './Simple';
import Textarea from './Textarea';
import ButtonList from './ButtonList';
import StudyGoal from './StudyGoal';
import { clickButton } from '../../actions/Modal';
import { compStatusTypes, MediaStatusTypes, ModalTypes } from '../../Constants';

import Style from './ModalView.cssmodule.less';

class ModalView extends BaseComponent {
    componentWillMount() {
        this.setNowItem(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.setNowItem(nextProps);
    }

    setNowItem = (nextProps) => {
        const { items = [], itemIndex = 0 } = nextProps;
        const maxIndex = items.length;
        this.nowItem =
            itemIndex <= maxIndex - 1 ? items[itemIndex] : items[maxIndex - 1];

        const { options = {} } = this.nowItem;
        const { parentClassName } = options;

        this.setState({
            parentClassName,
        });
    };

    createView() {
        if (this.props.status === compStatusTypes.HIDDEN) {
            return null;
        }
        let child = null;
        const { items = [], itemIndex = 0 } = this.props;
        const maxIndex = items.length;
        const item = this.nowItem;
        const { className } = item;
        switch (item.type) {
            case ModalTypes.HINT:
            case ModalTypes.PREBUILT_HINT:
            case ModalTypes.OUTRO:
            case ModalTypes.INTRO:
            case ModalTypes.LECTURE:
                const { media = {} } = item;
                const { category } = media;

                if (
                    maxIndex === 1 &&
                    (category === MediaStatusTypes.PROJECT_ELEMENT ||
                        category === MediaStatusTypes.PROJECT ||
                        category === MediaStatusTypes.LECTURE_PROJECT ||
                        category === MediaStatusTypes.LECTURE_PROJECT_ELEMENT ||
                        category === MediaStatusTypes.VIDEO)
                ) {
                    child = <Project item={item} theme={item.theme} />;
                } else {
                    child = (
                        <Intro
                            type={item.type}
                            item={item}
                            theme={item.theme}
                            itemIndex={itemIndex}
                            maxIndex={maxIndex}
                        />
                    );
                }

                break;
            case ModalTypes.ALERT:
                child = <Alert item={item} theme={item.theme} />;
                break;
            case ModalTypes.CONFIRM:
                child = <Confirm item={item} theme={item.theme} />;
                break;
            case ModalTypes.MAZE:
                child = (
                    <Maze
                        item={item}
                        theme={item.theme}
                        itemIndex={itemIndex}
                        maxIndex={maxIndex}
                    />
                );
                break;
            case ModalTypes.DIARY:
                child = <Diary item={item} theme={item.theme} />;
                break;
            case ModalTypes.MAZE_RESULT:
                child = <MazeResult item={item} theme={item.theme} />;
                break;
            case ModalTypes.FOLLOW:
                child = <Follow item={item} />;
                break;
            case ModalTypes.COMPLETE:
                child = <Complete item={item} theme={item.theme} />;
                break;
            case ModalTypes.HARDWARE_LIST:
                child = <HardwareList item={item} />;
                break;
            case ModalTypes.LECTURE_PROGRESS:
                child = <LectureProgress item={item} theme={item.theme} />;
                break;
            case ModalTypes.LECTURE_PROGRESS2:
                child = <LectureProgress2 item={item} theme={item.theme} />;
                break;
            case ModalTypes.TEXTBOOK_LECTURE_PROGRESS:
                child = (
                    <TextBookLectureProgress item={item} theme={item.theme} />
                );
                break;
            case ModalTypes.MANUAL:
                child = <Manual item={item} itemIndex={itemIndex} />;
                break;
            case ModalTypes.ELEMENT:
                child = <Element item={item} />;
                break;
            case ModalTypes.USER_SELECT_LIST:
                child = <UserSelectList item={item} />;
                break;
            case ModalTypes.LIST_EXPORT:
            case ModalTypes.LIST_IMPORT:
                child = <ListTransfer item={item} theme={item.theme} />;
                break;
            case ModalTypes.CURRICULUM_ALERT:
                child = <CurriculumAlert item={item} theme={item.theme} />;
                break;
            case ModalTypes.CURRICULUM_ANSWER:
                child = <CurriCulumAnswer item={item} />;
                break;
            case ModalTypes.CURRICULUM_HINT:
                child = (
                    <CurriculumStudyHint
                        type={item.type}
                        theme={item.theme}
                        item={item}
                        itemIndex={itemIndex}
                        maxIndex={maxIndex}
                    />
                );
                break;
            case ModalTypes.CURRICULUM_STUDY_COMPLETE:
                child = <CurriculumStudyComplete item={item} />;
                break;
            case ModalTypes.HARDWARE_DOWNLOAD:
                child = <HardwareDownload item={item} theme={item.theme} />;
                break;
            case ModalTypes.SIMPLE:
                child = <Simple item={item} theme={item.theme} />;
                break;
            case ModalTypes.TEXTAREA:
                child = <Textarea item={item} theme={item.theme} />;
                break;
            case ModalTypes.BUTTON_LIST:
                child = <ButtonList item={item} theme={item.theme} />;
                break;
            case ModalTypes.STUDY_GOAL:
                child = (
                    <StudyGoal
                        type={item.type}
                        theme={item.theme}
                        item={item}
                        itemIndex={itemIndex}
                        maxIndex={maxIndex}
                    />
                );
                break;
            default:
                child = null;
                break;
        }

        return (
            <div
                className={`${Style.modalViewChild} ${Style[className]}`}
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                {child}
            </div>
        );
    }

    render() {
        const { option = {} } = this.props;
        const { parentClassName = '' } = this.state || {};
        const { isCloseOutsideClick } = option;

        return (
            <div
                className={`${Style.modalView} ${this.props.status} ${parentClassName}`}
                onClick={(e) => {
                    if (isCloseOutsideClick) {
                        const { clickButton } = this.props.actions;
                        clickButton({
                            event: 'outside',
                        });
                    }
                }}
            >
                {this.createView()}
            </div>
        );
    }
}

ModalView.displayName = 'ModalView';
ModalView.propTypes = {
    item: PropTypes.object,
    emitter: PropTypes.any,
    option: PropTypes.object,
    theme: PropTypes.object,
};

function mapStateToProps(state) {
    const props = {
        itemIndex: state.Modal.itemIndex,
        status: state.Modal.status,
    };
    return props;
}

function mapDispatchToProps(dispatch) {
    const actions = { clickButton };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalView);



// WEBPACK FOOTER //
// ./components/ModalSet/ModalView.js